// DisaggregatedDataTable.js
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const sampleData = [
  { ID: 1, timestamp: '14/1/2020 8:59', PV_consumption: 3.82, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:00', PV_consumption: 8.52, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:01', PV_consumption: 3.78, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:02', PV_consumption: 3.53, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:03', PV_consumption: 3.57, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:04', PV_consumption: 3.75, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:05', PV_consumption: 4.05, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:06', PV_consumption: 4.08, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:07', PV_consumption: 7.82, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:08', PV_consumption: 4.15, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:09', PV_consumption: 4.13, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:10', PV_consumption: 4.23, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:11', PV_consumption: 4.20, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:12', PV_consumption: 4.22, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:13', PV_consumption: 4.52, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:14', PV_consumption: 8.77, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:15', PV_consumption: 4.48, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:16', PV_consumption: 4.45, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:17', PV_consumption: 3.92, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:18', PV_consumption: 3.92, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:19', PV_consumption: 3.87, PV_production: 0.0 },
  { ID: 1, timestamp: '14/1/2020 9:20', PV_consumption: 9.40, PV_production: 0.0 }
];


const DisaggregatedDataTable = () => {

  return (
    <div>
      <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'left', marginTop: 1, marginBottom: 2 }}>
        Sample Dataset
      </Typography>
    <TableContainer component={Paper} sx={{ width: '100%', margin: 'auto', maxHeight: 600, overflow: 'auto' }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {/* <TableCell align="center">ID</TableCell> */}
            <TableCell align="center">Timestamp</TableCell>
            <TableCell align="center">Consumption</TableCell>
            <TableCell align="center">PV Production</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sampleData.map((row, index) => (
            <TableRow key={index}>
              {/* <TableCell align="center">{row.ID}</TableCell> */}
              <TableCell align="center">{row.timestamp}</TableCell>
              <TableCell align="center">{row.PV_consumption}</TableCell>
              <TableCell align="center">{row.PV_production}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  );
};

export default DisaggregatedDataTable;
